import Head from 'next/head';
import TimelineSection from 'components/TimelineSection';

import styles from './LivePostsPage.module.scss';
// import CoinBanner from 'components/common/CoinBanner';
// import { INVITE_USER_COIN_EVENT } from 'common/utils';
import { GetTimelinePostsResult, PostParentKey } from 'common/interfaces/api';
import { useCallback } from 'react';
import { parse } from 'cookie';
import { NextPageContext } from 'next';
import { generateCookieList } from 'common/utils/trackingTag';
import { SITE_BASE_URL } from 'config/env';

const title = 'リアルタイムで投資・相場情報をLIVE配信で知れる | PostPrime';
const description =
  '日本株や米国株、コモディティ、暗号資産やFXなど様々な情報をLIVEでお届けします。お金を楽しく学べるPostPrimeで活躍中のクリエイター達のLIVE配信では質問などができるためあなたの投資を大きく促進させます。';
const url = `${SITE_BASE_URL}/post_topics/LIVE`;

export default function LivePostsPage(): JSX.Element {
  const getNextPageParamLivePosts = useCallback(
    (lastPage: GetTimelinePostsResult, pages: GetTimelinePostsResult[]) => {
      const posts = lastPage?.data?.posts;
      if (posts && posts.length > 0) {
        return pages.length + 1;
      }
    },
    []
  );

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta property="twitter:url" content={url} />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href={url} />
      </Head>
      <h1 style={{ display: 'none' }}>
        日本株・米国株・FXや暗号資産の最新情報をLIVE配信
      </h1>
      <div className={styles.timelineSection}>
        <div className={styles.content}>
          <TimelineSection
            apiUrl={`/feeds/lives`}
            queryKey={[PostParentKey.LiveTopics]}
            queryParamKey="page"
            getNextPageParam={getNextPageParamLivePosts}
            defaultPageParam={1}
          />
        </div>
      </div>
    </>
  );
}

export const getServerSideProps = (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || '')
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }
  return {
    props: {},
  };
};
